import React from 'react';
import {Provider} from 'react-redux';
import {applyMiddleware, createStore} from 'redux';
import thunkMiddleware from 'redux-thunk';
import {initAuth, SET_DATASET, SET_EMAIL, SET_SERVER_INFO, setDataset} from './actions';
import rootReducer from './reducers';
import AppWrapper from './AppWrapper';
// import * as serviceWorker from './serviceWorker';
import mixpanel from 'mixpanel-browser';
import {createRoot} from 'react-dom/client';

let useMixPanel = false;

const logger = (store) => (next) => (action) => {
  if (action.type === SET_SERVER_INFO) {
    if (action.payload.mixpanel) {
      mixpanel.init(action.payload.mixpanel);
      useMixPanel = true;
    }
  }
  if (useMixPanel) {
    if (action.type === SET_DATASET) {
      mixpanel.track('Open Dataset', {
        name: action.payload.name,
        id: action.payload.id,
      });
    } else if (action.type === SET_EMAIL) {
      mixpanel.identify(action.payload);
    }
  }
  return next(action);
};

const store = createStore(
  rootReducer,
  applyMiddleware(thunkMiddleware, logger),
);

// 监听数据集列表加载完成
let datasetChoicesReady = false;
store.subscribe(() => {
  const state = store.getState();
  if (!datasetChoicesReady && state.datasetChoices && state.datasetChoices.length > 0) {
    datasetChoicesReady = true;
    // 发送就绪消息
    if (window.parent !== window) {
      window.parent.postMessage({
        type: 'cirrocumulusDataReady',
        datasetChoices: state.datasetChoices
      }, '*');
      console.log('Cirrocumulus 数据已就绪，已发送通知');
    }
  }
});

// 监听消息
window.addEventListener('message', function(event) {
  if (event.data && event.data.type === 'setDataset') {
    const datasetId = event.data.datasetId;
    console.log('收到设置数据集消息:', datasetId);
    
    const datasetChoices = store.getState().datasetChoices;
    console.log('可用数据集列表:', datasetChoices);
    
    store.dispatch(setDataset(datasetId));
  }
});

// 应用初始化通知
if (window.parent !== window) {
  window.parent.postMessage({
    type: 'cirrocumulusInitialized'
  }, '*');
  console.log('Cirrocumulus 初始化完成，已发送通知');
}

// 只使用一个渲染调用 - 使用现代React API
const container = document.getElementById('root');
const root = createRoot(container);

function main() {
  root.render(
    <Provider store={store}>
      <AppWrapper />
    </Provider>,
  );
}

store.dispatch(initAuth());
main();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
// serviceWorker.unregister();
